import { useEffect } from 'react'
import { UseFormSetValue, FieldValues } from 'libs/form'
import { bookingOptionLabel } from 'features/products/hooks/useProductOptions'

type UseSetDefaultBookingProps = {
	bookings: any[]
	setValue: UseFormSetValue<FieldValues>
}

export const useSetDefaultBooking = ({ bookings, setValue }: UseSetDefaultBookingProps) => {
	useEffect(() => {
		if (bookings.length === 1) {
			setValue('booking', { value: bookings[0].id, label: bookingOptionLabel(bookings[0]) })
		}
	}, [bookings.length])
}
